import Participant from './Participant';

class LocalParticipant extends Participant {}

export default LocalParticipant;
